import React, { useState, useCallback } from 'react'
import Loading from 'Components/loading'
import { useBrandList, useScrollSpy } from 'Components/hooks'
import applyHttpsImage from 'lib/apply-https-img'

interface IBrandItem {
  id: number
  brand: string
}
interface IBrand {
  pinyin: string
  data: IBrandItem[]
}
interface IProp {
  show?: boolean
  style?: React.CSSProperties
  onChange: (id: number, name: string) => void
}

const Brand = ({ onChange, show = false, style = {} }: IProp) => {
  const [current, setCurrent, brandRef] = useScrollSpy<
    HTMLDivElement,
    HTMLDivElement
  >(
    useCallback((node) => {
      return node.querySelectorAll('.brand-item')
    }, []),
    false
  )
  const brands = useBrandList()

  function renderLetter() {
    if (!brands) {
      return null
    }
    return (
      <ul className="g-hover-scroll-bar">
        {brands.letters.map((letter, i) => (
          <li
            className={`${current === i ? 'active' : ''}`}
            key={letter}
            onClick={(e) => {
              e.stopPropagation()
              setCurrent(i)
            }}
          >
            {letter}
          </li>
        ))}
        <style jsx>
          {`
            ul {
              float: left;
              height: 100%;
              overflow-y: auto;
              @apply tw-bg-common-white;
            }
            li {
              width: 22px;
              height: 26px;
              color: #1a1a1a;
              font-size: 12px;
              line-height: 26px;
              text-align: center;
              cursor: pointer;
            }
            li.active {
              background: #ffe100;
            }
            li:hover {
              background-color: #ffe100 !important;
            }
          `}
        </style>
      </ul>
    )
  }

  function renderBrand() {
    if (!brands) {
      return null
    }
    return (
      <div className="brand-list g-hover-scroll-bar" ref={brandRef}>
        {brands.list.map((item) => {
          return (
            <div
              className="brand-item"
              key={item.letter}
              data-letter={item.letter}
            >
              <h4
                className="letter"
                key={item.letter}
                data-letter={item.letter}
              >
                {item.letter}
              </h4>
              {item.data.map((brand) => (
                <p
                  className="brand"
                  key={brand.id}
                  onClick={(e) => {
                    e.stopPropagation()
                    e.nativeEvent.stopPropagation()
                    e.nativeEvent.stopImmediatePropagation()
                    onChange(brand.id, brand.name)
                  }}
                >
                  {!!brand.avatar && (
                    <img
                      src={applyHttpsImage(brand.avatar || '')}
                      alt={brand?.name}
                    />
                  )}
                  <span>{brand?.name}</span>
                </p>
              ))}
            </div>
          )
        })}
        <style jsx>
          {`
            .brand-list {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin-left: 22px;
              overflow: auto;
              transform: translateZ(0);
              -webkit-overscroll-behavior: none;
            }
            h4 {
              position: sticky;
              top: 0;
              height: 28px;
              padding-left: 16px;
              line-height: 28px;
              font-size: 14px;
              border-bottom: 1px solid #e6e8f2;
              background: #fff;
            }
            p {
              padding: 8px;
              font-size: 14px;
              border-bottom: 1px solid #e6e8f2;
              @apply tw-text-common-black tw-cursor-pointer;
            }
            p:hover {
              background: rgb(255, 204, 50, 0.2);
            }
            p img {
              width: 22px;
              height: 22px;
              margin-right: 8px;
              border-radius: 50%;
              vertical-align: middle;
              display: inline-block;
            }
          `}
        </style>
      </div>
    )
  }
  if (!show) return null
  return (
    <section className="brand-selector" style={style}>
      {!brands && <Loading />}
      {renderLetter()}
      {renderBrand()}
      <style jsx>
        {`
          section {
            position: fixed;
            top: 120%;
            right: 0;
            width: 260px;
            background: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            overflow: hidden;
          }
        `}
      </style>
    </section>
  )
}

export default Brand
